import { ApiCacheTags, baseApiService } from '@qapline/api';
import { TCheckAttachmentUploadTokenResponseBody } from '@qapline/core/attachments';
import { config } from 'config';

import { TGetAttachmentUploadLinkRequestBody, TGetAttachmentUploadLinkResponseBody } from '../types';

export const attachmentsApi = baseApiService.injectEndpoints({
    endpoints: (builder) => ({
        checkUploadToken: builder.query<TCheckAttachmentUploadTokenResponseBody, void>({
            query: () => {
                return {
                    url: config.api.endpoints.attachments.checkUploadToken,
                    method: 'GET',
                };
            },
        }),
        getAttachmentUploadLink: builder.query<
            TGetAttachmentUploadLinkResponseBody,
            TGetAttachmentUploadLinkRequestBody
        >({
            query: ({ commissionId, renew }) => {
                return {
                    url: config.api.endpoints.attachments.generateUploadLink.replace(':id', commissionId.toString()),
                    method: 'GET',
                    params: {
                        renew,
                    },
                };
            },
            providesTags: (_, __, arg) => [{ type: ApiCacheTags.attachment.uploadLink, id: JSON.stringify(arg) }],
        }),
    }),
});

export const {
    useCheckUploadTokenQuery,
    useLazyCheckUploadTokenQuery,
    useGetAttachmentUploadLinkQuery,
    useLazyGetAttachmentUploadLinkQuery,
} = attachmentsApi;
